import { Box, Typography } from '@mui/material';
import { FRMAccountInsights, FRMTerritoryInsights } from '@trinity/custom-pages-registry';
import type { BuiltInCodePage } from '@trinity/management-app-client';

type Props = {
  codePage: BuiltInCodePage;
  pageName: string;
};

export function CustomCodeRenderer({ codePage, pageName }: Props): React.ReactElement {
  switch (codePage) {
    case 'frm-account-insights':
      return <FRMAccountInsights />;
    case 'frm-territory-insights':
      return <FRMTerritoryInsights />;
    default:
      return (
        <Box sx={{ p: 3 }}>
          <Typography variant="body2" color="text.secondary">
            This code page is not available yet.
          </Typography>
        </Box>
      );
  }
}
